import React from 'react'
import PropTypes from 'prop-types'
import style from './index.module.scss'

// The search indexes need to be configured with this. The default is <em> and
// </em> and we could use dangerouslySetInnerHTML, but that makes me
// uncomfortable.
const highlightStart = '__HL_START__'
const highlightEnd = '__HL_END__'
const highlightRegex = new RegExp(`${highlightStart}(.*?)${highlightEnd}`)

const TextWithHighlights = ({ hit, field }) => {
  const highlight = hit._highlightResult[field]
  const text = highlight ? hit._highlightResult[field].value : hit[field]

  // Elements will be a list of [out, in, out, in, ...]. Eg, if we search for
  // "shoe" in "nike shoes", elements will contain ["nike ", "shoe", "s"]
  const elements = text.split(highlightRegex)

  const htmlContent = []
  for (let i = 0; i < elements.length; i++) {
    const isHighlighted = i % 2 === 1 // eslint-disable-line no-magic-numbers
    htmlContent.push(
      isHighlighted ? <em key={i.toString()}>{elements[i]}</em> : elements[i]
    )
  }

  return <div className={style.textWithHighlights}>{htmlContent}</div>
}

TextWithHighlights.propTypes = {
  field: PropTypes.string,
  hit: PropTypes.object,
}

export default TextWithHighlights
